import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';
import { ConfigService } from '../../services/config/config.service';
import { WindowService } from '../../services/window/window.service';
import { UserMasterService } from '../../services/user-master/user-master.service';

@Component({
    selector: 'pace-core-corporate-information',
    templateUrl: './corporate-information.component.html',
    styleUrls: ['./corporate-information.component.scss'],
})
export class CorporateInformationComponent {
    public strings: CorporateInformationStrings;
    private window: Window;
    public displayCorpSupport: boolean;

    public isWindows: boolean;
    public constructor(
        private readonly translate: TranslateService,
        public readonly modalInstance: BsModalRef,
        window: WindowService,
        private readonly configService: ConfigService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
        private readonly userMasterService: UserMasterService,
    ) {
        this.window = window.nativeWindow;
        this.displayCorpSupport = !this.userMasterService.isPaceOnlineUser() && !this.clientManager.isPaceFormsFI();
        this.strings = {
            appVersion: `v${this.clientManager.getAppVersion()}`,
            corpInfoHQ1: this.configService.getCorpInfoHQ1(),
            corpInfoHQ2: this.configService.getCorpInfoHQ2(),
            corpInfoHQ3: this.configService.getCorpInfoHQ3(),
            corpInfoHQ4: this.configService.getCorpInfoHQ4(),
            corpInfoHQ5: this.configService.getCorpInfoHQ5(),
            corpInfoHQ5Link: this.configService.getCorpInfoHQ5Link(),
            corpInfoHQTel: this.configService.getCorpInfoHQTel(),
            corpInfoSupportHours: this.configService.getCorpInfoSupportHours(),
            corpInfoSupportEmail: this.configService.getCorpInfoSupportEmail(),
            corpInfoSupportLink: this.configService.getCorpInfoSupportLink(),
            corpInfoSupportCreateTicketLink: this.configService.getCorpInfoSupportCreateTicketLink(),
            corpInfoLegalInfo1: this.configService.getCorpInfoLegalInfo1(),
            corpInfoLegalInfo2: this.configService.getCorpInfoLegalInfo2(),
            corpInfoLegalInfo3: this.configService.getCorpInfoLegalInfo3(),
            corpInfoLegalInfo4: this.configService.getCorpInfoLegalInfo4(),
            corpInfoLegalInfo5: this.configService.getCorpInfoLegalInfo5(),
            corpInfoLegalInfo6: this.configService.getCorpInfoLegalInfo6(),
            CorpInfoLegalInfo7: this.configService.getCorpInfoLegalInfo7(),
            corpInfoLegalPrivacyPolicyLabel: this.configService.getCorpInfoLegalInfoPolicy(),
            corpInfoLegalPrivacyPolicyLink: this.configService.getCorpInfoLegalInfoPolicyLink(),
            corpInfoLegalTOULabel: this.configService.getCorpInfoLegalInfoTOU(),
            corpInfoLegalTOULink: this.configService.getCorpInfoLegalInfoTOULink(),
            corpInfoLegalPolicyMonth: this.configService.getCorpInfoLegalPolicyMonth(),
        };

        this.isWindows = this.clientManager.isWindows();
    }

    public openTel(tel: string): void {
        this.window.location.href = `tel:${this.translate.instant(tel)}`;
    }

    public openEmail(email: string): void {
        this.window.location.href = `mailto:${this.translate.instant(email)}`;
    }

    // this method is being called only from the windows app.
    // this method is required, otherwise, the links will be open in the cordova inappbrowser
    public openLink(link: string): void {
        this.window.location.href = link;
    }
}

interface CorporateInformationStrings {
    appVersion: string;
    corpInfoHQ1: string;
    corpInfoHQ2: string;
    corpInfoHQ3: string;
    corpInfoHQ4: string;
    corpInfoHQ5: string;
    corpInfoHQ5Link: string;
    corpInfoHQTel: string;
    corpInfoSupportHours: string;
    corpInfoSupportEmail: string;
    corpInfoSupportLink: string;
    corpInfoSupportCreateTicketLink: string;
    corpInfoLegalInfo1: string;
    corpInfoLegalInfo2: string;
    corpInfoLegalInfo3: string;
    corpInfoLegalInfo4: string;
    corpInfoLegalInfo5: string;
    corpInfoLegalInfo6: string;
    CorpInfoLegalInfo7: string;
    corpInfoLegalPrivacyPolicyLabel: string;
    corpInfoLegalPrivacyPolicyLink: string;
    corpInfoLegalTOULabel: string;
    corpInfoLegalTOULink: string;
    corpInfoLegalPolicyMonth: string;
}
